import Loadable from 'react-loadable'

const ChannelStories = Loadable({
    loader: () => import(/* webpackChunkName: "desktopChannelStories" */ './channel-stories'),
    loading: () => null,
})

const ChannelStoriesRoute = ({
    match: {
        params: { username },
    },
}) => <ChannelStories username={username} />

export default ChannelStoriesRoute
